import { request } from "../../api/api";

export const getExtruderStatus = (plant_id) => {
    return request.get(`/extruder_status/getExtruderStatus/?plant_id=${plant_id}`)
}

export const updateExtruderSize = (data) => {
    return request.post('/extruder_status/updateExtruderSize/', (data));
}